import {
  GetUserAuthToken,
  GetUserDetails,
  GetUserFaculties,
  StoreUserAuthToken,
  StoreUserDetails,
  StoreUserFaculties,
  StoreUserType,
} from '../../services/config'
import * as React from 'react'
import { IUserDetails, IUserType } from '../../interfaces/user.interface'
import {
  useGlobalStoreActions,
  useGlobalStoreState,
} from '../../store/globalStore'
import { AnalyticService } from '../../lib/analytics/analyticService'
import { GetMyDetailsRequest } from '@/services/api-requests/api-request'
import { IFacultyStudent } from '../Faculties/IFaculty'

export interface IAuthDetails {
  authToken?: string
  userType?: IUserType
  userDetails?: IUserDetails
  userFaculties: IFacultyStudent[]
}

const useUserAuthStatus = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = React.useState(false)

  const storeAuthDetails = useGlobalStoreActions(
    action => action.storeAuthDetails,
  )
  const authDetails = useGlobalStoreState(state => state.authDetails)
  const [userDetails, setUserDetails] = React.useState<
    IUserDetails | undefined
  >(authDetails?.userDetails)

  React.useEffect(() => {
    setIsUserLoggedIn(!!authDetails?.userDetails)
    authDetails?.userDetails && setUserDetails(authDetails.userDetails)
  }, [authDetails])

  const initialiseAuthHook = async () => {
    const _userDetails = GetUserDetails()
    const userFaculties = GetUserFaculties()

    const _authDetails: IAuthDetails = {
      authToken: GetUserAuthToken() || undefined,
      userType: _userDetails?.user_type,
      userDetails: GetUserDetails(),
      userFaculties: userFaculties,
    }

    storeAuthDetails(_authDetails)
  }

  const refreshSchoolUserDetails = async (): Promise<
    IUserDetails | undefined
  > => {
    const _userDetails = GetUserDetails()
    if (!_userDetails || _userDetails?.user_type === 'account_user') {
      return
    }
    const userDetailsRequest = await GetMyDetailsRequest()
    if (userDetailsRequest?.data?.data?.details) {
      StoreUserDetails(userDetailsRequest?.data?.data?.details)
      StoreUserFaculties(userDetailsRequest?.data?.data?.user_faculties)
      initialiseAuthHook()
      return userDetailsRequest?.data?.data?.details
    } else {
      console.log('Error refreshing user details')
      return
    }
  }

  const loginUser = (userData: any) => {
    console.log({ userData })

    const token = userData.token
    const user_type = userData.user_type
    StoreUserAuthToken(token)
    StoreUserType(user_type)
    StoreUserDetails(userData)
    refreshSchoolUserDetails()

    // initialiseAuthHook()
  }

  const logout = (redirectUrl?: string) => {
    localStorage.clear()
    sessionStorage.clear()
    storeAuthDetails(undefined)

    AnalyticService.onAdminUserLogout()

    if (redirectUrl) {
      location.href = redirectUrl
    } else {
      location.reload()
    }
  }

  return {
    isLoggedIn: isUserLoggedIn,
    initialiseAuthHook: initialiseAuthHook,
    loginUser: loginUser,
    logout: logout,
    userDetails: userDetails,
    authDetails: authDetails,
    refreshSchoolUserDetails,
  }
}

export default useUserAuthStatus
